// ESM re-export of the CJS-tested alternatives helpers, so the JSX can import
// them while Jest unit-tests the .cjs sibling directly (no ESM transform under
// Jest). esbuild bundles the CJS module fine. Same pattern as
// order-doc-helpers.js.
export {
  altReasonLabel,
  alternativeOptions,
  moreLabel,
  nextActiveIndex,
  commitFor,
  swapAnnouncement,
  extraCodes,
  hintFor,
  gainedUnresolved,
} from './test-alternatives.cjs';
